import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const listMerchantByPrograms = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "agent",
      pid: "ListMerchantByPrograms",
      dat: {
        // programid: "227",
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
